const getItem = key => {
  if (localStorage) {
    try {
      return JSON.parse(
      // @ts-expect-error
      localStorage.getItem(key));
    } catch (error) {
      return null;
    }
  }
  return null;
};
const setItem = (key, value) => {
  if (localStorage) {
    localStorage.setItem(key, JSON.stringify(value));
  }
};
const mergeItem = (key, value) => {
  if (localStorage) {
    const originalValue = getItem(key);
    localStorage.setItem(key, JSON.stringify({
      ...originalValue,
      ...value
    }));
  }
};
const removeItem = key => {
  if (localStorage) {
    localStorage.removeItem(key);
  }
};
const clear = () => {
  if (localStorage) {
    localStorage.clear();
  }
};
export default {
  getItem,
  setItem,
  mergeItem,
  removeItem,
  clear
};